<jw-modal id='jobSignOffChargesOnlyModal'>
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }

  <h1 class='header'>Select Charges</h1>

  <div class="form-row">
    <div class="form-group col-md-12">
      <label for="inputEmail4">Reason for wasted journey</label>
      <textarea class='form-control' [(ngModel)]='this.job.notes'></textarea>
    </div>
  </div>

  <!-- <div class="form-group col-md-12">
  <label for="inputEmail4">Chargeable</label>
  <input type='checkbox' class='form-control'  [ngModelOptions]="{standalone: true}" [(ngModel)]='this.job.chargeable' />
</div> -->


<button class='btn btn-secondary' (click)='this.priceListType = "quote"; this.orderLines = []' [class.btn-success]='this.priceListType === "quote"' type='button'>Quote</button>&nbsp;&nbsp;
<button class='btn btn-secondary' (click)='this.priceListType = "pricelist"; this.orderLines = []' [class.btn-success]='this.priceListType === "pricelist"' type='button'>Price List</button>


@if (this.priceListType === "pricelist") {
  <div class="form-row">
    <div class="form-group col-md-12">
      <label for="inputEmail4">Price List</label>
      <select class='form-control' (change)='this.onPriceListChanged($event)'>
        <option value='-1'>Select a price list</option>
        @for (item of this.priceLists; track item) {
          <option [value]='item.id'>{{ item.name }}</option>
        }
      </select>
    </div>
  </div>
  @if (this.pricelistItems.length > 0) {
    <div class="form-row">
      <div class="form-group col-md-12">
        <label for="inputEmail4">Price List Item</label>
        <select class='form-control' (change)='this.priceListItemId = +$event.target.value;'>
          <option value='-1'>Select a price list item</option>
          @for (item of this.pricelistItems; track item) {
            <option [value]='item.id'>{{ item.name }} &pound;{{ item.price }} ( {{ item.unit.name }} )</option>
          }
        </select>
      </div>
    </div>
    <button class='btn btn-secondary' (click)='onAddItemForPriceList()'>+ Add Item</button><br /><br />
  }
  @if (this.orderLines.length > 0) {
    <table class="table">
      <thead>
        <th>Name</th>
        <th>Qty</th>
        <th>Unit</th>
        <th>Base Price(&pound;)</th>
        <th>Total Price(&pound;)</th>
      </thead>
      <tbody>
        @for (item of this.orderLines; track item) {
          <tr>
            <td>{{ item.name }}</td>
            <td>
              <input type="number" min='0' name='name' class="form-control" id="inputEmail4" [(ngModel)]='item.qty'>
            </td>
            <td>
              {{ item.unit.name }}(s)
            </td>
            <td>
              {{ item.price }}
            </td>
            <td>
              {{ getTotalPriceForOrderLine(item).toFixed(2) }}
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
}
@if (this.priceListType === "quote") {
  <div class="form-row">
    <div class="form-group col-md-12">
      <label for="inputEmail4">Quote</label>
      <select class='form-control' (change)='this.onQuoteChanged($event)'>
        <option value='-1'>Select a quote</option>
        @for (item of this.quotes; track item) {
          <option [value]='item.id'>{{ item.name }}({{ item.quoteNumber }}))</option>
        }
      </select>
    </div>
  </div>
  @if (this.quoteLines.length > 0) {
    <table class="table">
      <thead>
        <th>Name</th>
        <th>Qty</th>
        <th>Unit</th>
        <th>Base Price(&pound;)</th>
        <th>Total Price(&pound;)</th>
      </thead>
      <tbody>
        @for (item of this.orderLines; track item) {
          <tr>
            <td>{{ item.quoteLine.product.name }}</td>
            <td>
              <input type="number" min='0' name='name' class="form-control" id="inputEmail4" [(ngModel)]='item.qty'>
            </td>
            <td>
              {{ item.quoteLine.product.unit.name }}(s)
            </td>
            <td>
              {{ item.price }}
            </td>
            <td>
              {{ getTotalPriceForOrderLine(item).toFixed(2) }}
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
}

<button class='btn btn-success' (click)='this.save()'>Save</button>&nbsp;
<button class='btn btn-danger' (click)='this.close()'>Cancel</button>
</jw-modal>
